import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, NgZone, ViewContainerRef } from '@angular/core';
import { MapApi } from '../../../api/map-api';
import { Interceptor } from '../../../classes/interceptor';
import { util } from '../../../classes/util';
import { ESRI } from '../../../esri-loader-util';
import { BooleanConverter, InputConverter, JSONConverter } from '../../../inputConverter';
import { AoiService } from '../../../services/aoi.service';
import { ComponentService } from '../../../services/component.service';
import { DeepLinkProcessor } from '../../../services/deep-link-processor.service';
import { DeepLinkService } from '../../../services/deep-link.service';
import { DocumentService } from '../../../services/document.service';
import { LayerService } from '../../../services/layer.service';
import { MapService } from '../../../services/map.service';
import { NearbyService } from '../../../services/nearby.service';
import { QueryStringParamService } from '../../../services/query-string-param-service';
import { ScalebarService } from '../../../services/scalebar.service';
import { SpatialQueryService } from '../../../services/spatialQuery.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { HeatmapMode } from '../../../types';
import { BaseComponent } from '../../base.component';
import { CreateBasemapsFromConfig } from '../basemap-switcher/basemap-config';
var MapConstructor;
var MapViewConstructor;
var defaultLatitude = -76.9743399;
var defaultLongitude = 40.2684045;
var defaultZoom = 11;
/** Map Component - Displays an ESRI map */
var MapComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MapComponent, _super);
    function MapComponent(vcr, changeDetectorRef, componentService, mapApi, layerService, mapService, aoiService, scalebarService, toSqlStringService, spatialQueryService, deepLinkService, deepLinkProcessor, queryStringParamService, nearbyService, $window, zone, documentService, userSettingsService) {
        var _this = _super.call(this, vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.componentService = componentService;
        _this.mapApi = mapApi;
        _this.layerService = layerService;
        _this.mapService = mapService;
        _this.aoiService = aoiService;
        _this.scalebarService = scalebarService;
        _this.toSqlStringService = toSqlStringService;
        _this.spatialQueryService = spatialQueryService;
        _this.deepLinkService = deepLinkService;
        _this.deepLinkProcessor = deepLinkProcessor;
        _this.queryStringParamService = queryStringParamService;
        _this.nearbyService = nearbyService;
        _this.zone = zone;
        _this.documentService = documentService;
        _this.userSettingsService = userSettingsService;
        _this.defaultComponents = [];
        _this.center = [defaultLatitude, defaultLongitude];
        _this._basemap = 'streets-vector';
        _this._rotate = true;
        _this._enableClickEvents = true;
        _this._enablePointerMoveEvents = true;
        _this._processDeepLinkOnLoad = true;
        _this._enableZoom = true;
        _this._showAttribution = true;
        _this.zoom = defaultZoom;
        _this.largerImageRequest = new EventEmitter();
        _this.largerVideoRequest = new EventEmitter();
        _this.loadListeners = new Map();
        _this.layerViewsChange = function (event) {
            var e_1, _a;
            if (event && event.added && event.added.length) {
                try {
                    for (var _b = tslib_1.__values(event.added), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var layerView = _c.value;
                        _this.loadListeners.set(layerView.layer.id, layerView.watch('updating', function (current, _old, _prop, target) {
                            window.dispatchEvent(new CustomEvent('layerUpdatingChange', { detail: { layerId: target.layer.id, updating: current }, composed: true }));
                        }));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        };
        _this.layersChange = function (event) {
            var e_2, _a;
            if (event && event.removed && event.removed.length) {
                try {
                    for (var _b = tslib_1.__values(event.removed), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var layer = _c.value;
                        var handler = _this.loadListeners.get(layer.id);
                        if (handler) {
                            handler.remove();
                            _this.loadListeners.delete(layer.id);
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        };
        _this.disposeMap = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.unregisterWithMcScope()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.zoomToLayer = function (layerId, zoomThreshold) {
            if (zoomThreshold === void 0) { zoomThreshold = 14; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.layerService.zoomToLayer(layerId, zoomThreshold)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.activate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var mapView, layerService_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                mapView = this.mapView;
                if (!this.pointerMoveHandler && this.enablePointerMoveEvents) {
                    this.pointerMoveHandler = mapView.on('pointer-move', function (event) {
                        mapView.hitTest(event)
                            .then(function (response) {
                            var cursorStyle = 'default';
                            if (response.results.filter(function (r) { return r.graphic.layer && r.graphic.layer.type === 'graphics'; }).length > 0) {
                                cursorStyle = 'pointer';
                            }
                            var map = document.getElementsByTagName('mc-map');
                            if (map !== null && map.length === 1) {
                                map[0].style.cursor = cursorStyle;
                            }
                        });
                    });
                }
                if (!this.clickHandler && this.enableClickEvents) {
                    layerService_1 = this.layerService;
                    this.clickHandler = mapView.on('click', function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            window.dispatchEvent(new CustomEvent('mapUpdateBegin', { detail: '' }));
                            mapView.hitTest(event)
                                .then(function (response) {
                                return tslib_1.__awaiter(this, void 0, void 0, function () {
                                    var segmentKeyName_1, retryCountMax, retryCount, continueSegmentSearch, performAdditionalSearch, additionalSearchDistanceInFeet, searchDistanceAdjustment, searchDistanceAdjustmentIncrease, searchDistanceAdjustmentDecrease, currentSegment_1, _loop_1;
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!(response.results.filter(function (r) { return r.graphic.layer.type === 'graphics'; }).length > 0)) return [3 /*break*/, 3];
                                                segmentKeyName_1 = 'SEG_NO';
                                                retryCountMax = 5;
                                                retryCount = 0;
                                                continueSegmentSearch = true;
                                                performAdditionalSearch = false;
                                                additionalSearchDistanceInFeet = 0;
                                                searchDistanceAdjustment = Math.max(4, layerService_1.getTolerance(1));
                                                searchDistanceAdjustmentIncrease = Math.max(4, searchDistanceAdjustment * 0.2);
                                                searchDistanceAdjustmentDecrease = Math.max(4, searchDistanceAdjustment * 0.1);
                                                currentSegment_1 = layerService_1.selectedLayer == null
                                                    ? ''
                                                    : layerService_1.selectedLayer.title.split('|')[2];
                                                _loop_1 = function () {
                                                    var results;
                                                    return tslib_1.__generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, layerService_1.identifyMapImagelayers(event.mapPoint, false, false, 1, additionalSearchDistanceInFeet)];
                                                            case 1:
                                                                results = (_a.sent()).features;
                                                                performAdditionalSearch = false;
                                                                // If no results, then increase search distance
                                                                // Else if segment(s) found that is current segment, then done searching (may find multiple that represent same segment)
                                                                // Else if segment(s) found that is not current segment but it same segment, then done searching and make new selection (may find multiple that represent same segment)
                                                                // Otherwise, combination of current segment and other segments so decrease search distance to narrow results
                                                                if (results.length === 0) {
                                                                    retryCount++;
                                                                    // If not yet reached maximum number of searches
                                                                    // Else if reached maximum number of searches, then do one final search with much larger search distance
                                                                    if (retryCount < retryCountMax) {
                                                                        additionalSearchDistanceInFeet += searchDistanceAdjustmentIncrease;
                                                                    }
                                                                    else if (retryCount === retryCountMax) {
                                                                        additionalSearchDistanceInFeet = additionalSearchDistanceInFeet * 2;
                                                                        performAdditionalSearch = true;
                                                                    }
                                                                }
                                                                else if (results.filter(function (r) { return r.attributes[segmentKeyName_1] !== currentSegment_1; }).length === 0) {
                                                                    continueSegmentSearch = false;
                                                                }
                                                                else if (results.every(function (r) { return r.attributes[segmentKeyName_1] === results[0].attributes[segmentKeyName_1]; })) {
                                                                    continueSegmentSearch = false;
                                                                    window.dispatchEvent(new CustomEvent('selectSegment', { detail: results[0].attributes[segmentKeyName_1] }));
                                                                }
                                                                else {
                                                                    additionalSearchDistanceInFeet -= searchDistanceAdjustmentDecrease;
                                                                    retryCount++;
                                                                    // If reached maxiumum number of searches or completed additional search
                                                                    if (retryCount >= retryCountMax) {
                                                                        // Remove result(s) that match selected segment
                                                                        results = results.filter(function (r) { return r.attributes[segmentKeyName_1] !== currentSegment_1; });
                                                                        // Select first result; this is ok because this scenario should only happen if very zoomed out and precision will be lacking
                                                                        window.dispatchEvent(new CustomEvent('selectSegment', { detail: results[0].attributes[segmentKeyName_1] }));
                                                                    }
                                                                }
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                };
                                                _a.label = 1;
                                            case 1:
                                                if (!((continueSegmentSearch && retryCount < retryCountMax) || performAdditionalSearch)) return [3 /*break*/, 3];
                                                return [5 /*yield**/, _loop_1()];
                                            case 2:
                                                _a.sent();
                                                return [3 /*break*/, 1];
                                            case 3:
                                                window.dispatchEvent(new CustomEvent('mapUpdateEnd', { detail: '' }));
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            });
                            return [2 /*return*/];
                        });
                    }); });
                }
                return [2 /*return*/];
            });
        }); };
        _this.$window = $window;
        _this.largerImageSubscription = _this.documentService.fullScreenImagesRequestedObservable.subscribe(function (documents) { return _this.onLargerImageRequested(documents); });
        _this.largerVideoSubscription = _this.documentService.fullScreenVideoRequestedObservable.subscribe(function (document) { return _this.onLargerVideoRequested(document); });
        _this.registerEvent('largerImageRequest', _this.largerImageRequest);
        window.addEventListener('showRouteAndSegmentMapLayersFromQueryParameters', function () {
            _this.showRouteAndSegmentMapLayersFromQueryParameters();
        });
        return _this;
    }
    Object.defineProperty(MapComponent.prototype, "basemap", {
        get: function () {
            if (this.map && this.map.basemap) {
                return this.map.basemap.id;
            }
            else {
                return this._basemap;
            }
        },
        set: function (value) {
            this._basemap = value;
            if (this.mapView && this.mapView.map) {
                this.mapView.map.set('basemap', this._basemap);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "rotate", {
        get: function () { return this._rotate; },
        set: function (value) {
            this._rotate = BooleanConverter(value);
            if (this.mapView && this.mapView.constraints) {
                this.mapView.constraints.rotationEnabled = this._rotate;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "enableClickEvents", {
        get: function () { return this._enableClickEvents; },
        set: function (value) {
            this._enableClickEvents = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "enablePointerMoveEvents", {
        get: function () { return this._enablePointerMoveEvents; },
        set: function (value) {
            this._enablePointerMoveEvents = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "processDeepLinkOnLoad", {
        get: function () { return this._processDeepLinkOnLoad; },
        set: function (value) {
            this._processDeepLinkOnLoad = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "enableZoom", {
        get: function () { return this._enableZoom; },
        set: function (value) {
            this._enableZoom = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "showAttribution", {
        get: function () { return this._showAttribution; },
        set: function (value) {
            this._showAttribution = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "LayerService", {
        get: function () {
            return this.layerService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "MapService", {
        get: function () {
            return this.mapService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "AoiService", {
        get: function () {
            return this.aoiService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "DeepLinkService", {
        get: function () {
            return this.deepLinkService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "ScalebarService", {
        get: function () {
            return this.scalebarService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "ToSqlStringService", {
        get: function () {
            return this.toSqlStringService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "SpatialQueryService", {
        get: function () {
            return this.spatialQueryService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "UserSettingsService", {
        get: function () {
            return this.userSettingsService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapComponent.prototype, "EsriInterceptor", {
        get: function () {
            return Interceptor;
        },
        enumerable: true,
        configurable: true
    });
    MapComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, registerWithMcScopePromise, seconds, err_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        registerWithMcScopePromise = this.registerWithMcScope();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 11, 12, 13]);
                        return [4 /*yield*/, Promise.all([ESRI.MCMap, ESRI.MCMapView, ESRI.Basemap, ESRI.WebTileLayer])];
                    case 2:
                        // tell any parent mcScope that we exist.
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), MapConstructor = _a[0], MapViewConstructor = _a[1];
                        return [4 /*yield*/, this.zone.runOutsideAngular(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return tslib_1.__generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (this.enableZoom) {
                                                this.defaultComponents.push('zoom');
                                            }
                                            if (this.showAttribution) {
                                                this.defaultComponents.push('attribution');
                                            }
                                            this.map = MapConstructor({ basemap: this.basemap });
                                            _a = this;
                                            return [4 /*yield*/, MapViewConstructor({
                                                    center: this.center,
                                                    container: this.mapAreaRef.nativeElement,
                                                    map: this.map,
                                                    ui: { components: this.defaultComponents },
                                                    zoom: this.zoom
                                                }, this.mapId, this.mapApi, this.layerService)];
                                        case 1:
                                            _a.mapView = _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 3:
                        _b.sent();
                        this.mapView.allLayerViews.on('change', this.layerViewsChange);
                        this.map.allLayers.on('change', this.layersChange);
                        //map constraints set after initialization because it doesn't seem to work
                        //in the initialization, but works out here
                        this.mapView.constraints = {
                            rotationEnabled: this.rotate
                        };
                        this.map.watch('basemap', function (newValue) { _this._basemap = newValue; });
                        this.mapView.watch('center', function (newValue) { _this.center = [newValue.longitude, newValue.latitude]; });
                        this.mapView.watch('zoom', function (newValue) {
                            _this.zoom = newValue;
                            _this.mapView.map.allLayers.forEach(function (layer) {
                                if (layer.type === 'feature') {
                                    var featureLayer = layer;
                                    if (featureLayer.mapcoreProps && featureLayer.mapcoreProps.heatmapMode && featureLayer.mapcoreProps.heatmapMode === HeatmapMode.Auto) {
                                        var heatmapOn = _this.layerService.checkIfHeatmapIsOnOrOff(layer);
                                        if (heatmapOn) {
                                            featureLayer.renderer = featureLayer.mapcoreProps.heatmapRenderer;
                                        }
                                        else {
                                            featureLayer.renderer = featureLayer.mapcoreProps.renderer;
                                        }
                                    }
                                }
                            });
                            _this.changeDetectorRef.detectChanges();
                        });
                        this.mapService.mcMapView = this.mapView;
                        this.layerService.mapView = this.mapView;
                        this.aoiService.mapView = this.mapView;
                        return [4 /*yield*/, this.setupWidgets()];
                    case 4:
                        _b.sent();
                        return [4 /*yield*/, registerWithMcScopePromise];
                    case 5:
                        _b.sent();
                        if (!(this.$window.location.search.indexOf('?') >= 0 && this.processDeepLinkOnLoad)) return [3 /*break*/, 7];
                        seconds = 500;
                        return [4 /*yield*/, setTimeout((function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    if (this.$window.location.search.indexOf('?') >= 0) {
                                        //register mapcore deep link handlers last, so hosts had a chance to register first
                                        this.mapView.when(function () {
                                            _this.deepLinkService.registerDeepLinkProcessors();
                                            _this.deepLinkProcessor.process();
                                            window.dispatchEvent(new CustomEvent('openAoi', { detail: false, composed: true }));
                                        });
                                    }
                                    return [2 /*return*/];
                                });
                            }); }), seconds)];
                    case 6:
                        _b.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        window.dispatchEvent(new CustomEvent('openAoi', { detail: true, composed: true }));
                        _b.label = 8;
                    case 8: return [4 /*yield*/, this.mapView.when()];
                    case 9:
                        _b.sent();
                        return [4 /*yield*/, this.activate()];
                    case 10:
                        _b.sent();
                        return [3 /*break*/, 13];
                    case 11:
                        err_1 = _b.sent();
                        this.readyProblem(err_1);
                        throw err_1;
                    case 12:
                        this.componentService.mapViewReady(this.mapView);
                        this.isReady();
                        return [7 /*endfinally*/];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    MapComponent.prototype.setupWidgets = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, slots, slots_1, slots_1_1, slot;
            return tslib_1.__generator(this, function (_b) {
                slots = [
                    { key: 'bottom-left', element: this.slotBottomLeft },
                    { key: 'bottom-right', element: this.slotBottomRight },
                    { key: 'top-left', element: this.slotTopLeft },
                    { key: 'top-right', element: this.slotTopRight }
                ];
                try {
                    for (slots_1 = tslib_1.__values(slots), slots_1_1 = slots_1.next(); !slots_1_1.done; slots_1_1 = slots_1.next()) {
                        slot = slots_1_1.value;
                        if (slot && slot.element.nativeElement.assignedNodes().length > 0) {
                            this.mapView.ui.add(slot.element.nativeElement, slot.key);
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (slots_1_1 && !slots_1_1.done && (_a = slots_1.return)) _a.call(slots_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    MapComponent.prototype.setBasemapsFromConfig = function (basemapConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.LayerService.getLayerCopyRight(basemapConfig)];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, CreateBasemapsFromConfig(basemapConfig)];
                    case 2:
                        _a.basemap = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapComponent.prototype.showRouteAndSegmentMapLayersFromQueryParameters = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, routeLayer, queryStringParameters, segmentNumberParameterKeyName, searchCriteriaParametersWithSegment, searchCriteriaParametersWithoutSegment, _b, searchCriteriaParameters, routeAndSegmentBufferTitle, routeLinePoints, segmentLinePoints, linePoints, startX, startY, endX, endY, dy, dx, theta;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        window.dispatchEvent(new CustomEvent('mapUpdateBegin', { detail: '' }));
                        _c.label = 1;
                    case 1:
                        if (!!this.mapView) return [3 /*break*/, 3];
                        return [4 /*yield*/, util.sleep(10)];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 1];
                    case 3:
                        queryStringParameters = this.queryStringParamService.getQueryStringParams();
                        if (!this.deepLinkService.deepLinkParamIsPresent('segmentNumber')) return [3 /*break*/, 8];
                        segmentNumberParameterKeyName = 'segmentNumber';
                        searchCriteriaParametersWithSegment = this.deepLinkProcessor.getParameters(this.deepLinkService.parameters, queryStringParameters);
                        (this.deepLinkService.parameters[segmentNumberParameterKeyName]).forEach(function (p) {
                            delete queryStringParameters[p]; //tslint:disable-line
                        });
                        searchCriteriaParametersWithoutSegment = this.deepLinkProcessor.getParameters(this.deepLinkService.parameters, queryStringParameters);
                        return [4 /*yield*/, this.setSearchCriteriaFromQueryParameters(searchCriteriaParametersWithoutSegment)];
                    case 4:
                        _c.sent();
                        return [4 /*yield*/, this.aoiService.showLayersFromQueryParameters(true, false, 'rgba(255, 128, 0, 1)')];
                    case 5:
                        routeLayer = _c.sent();
                        return [4 /*yield*/, this.setSearchCriteriaFromQueryParameters(searchCriteriaParametersWithSegment)];
                    case 6:
                        _c.sent();
                        _b = this.layerService;
                        return [4 /*yield*/, this.aoiService.showLayersFromQueryParameters(false, true, 'rgba(255, 0, 0, 1)')];
                    case 7:
                        _b.selectedLayer = _c.sent();
                        return [3 /*break*/, 11];
                    case 8:
                        searchCriteriaParameters = this.deepLinkProcessor.getParameters(this.deepLinkService.parameters, queryStringParameters);
                        return [4 /*yield*/, this.setSearchCriteriaFromQueryParameters(searchCriteriaParameters)];
                    case 9:
                        _c.sent();
                        return [4 /*yield*/, this.aoiService.showLayersFromQueryParameters(true, true, 'rgba(255, 128, 0, 1)')];
                    case 10:
                        routeLayer = _c.sent();
                        this.layerService.selectedLayer = null;
                        _c.label = 11;
                    case 11:
                        routeAndSegmentBufferTitle = 'Route and Segment Buffer';
                        this.layerService.mapLayers.graphics.forEach(function (layer) {
                            if (layer.title === routeAndSegmentBufferTitle) {
                                layer.removeAll();
                            }
                        });
                        routeLinePoints = [];
                        segmentLinePoints = [];
                        return [4 /*yield*/, Promise.all([
                                this.getLinePointsAndCreateLineBuffer(routeLayer, routeAndSegmentBufferTitle, this.layerService.selectedLayer == null, true),
                                this.getLinePointsAndCreateLineBuffer(this.layerService.selectedLayer, routeAndSegmentBufferTitle, this.layerService.selectedLayer != null, false)
                            ])];
                    case 12:
                        _a = tslib_1.__read.apply(void 0, [_c.sent(), 2]), routeLinePoints = _a[0], segmentLinePoints = _a[1];
                        linePoints = this.layerService.selectedLayer !== null ? segmentLinePoints : routeLinePoints;
                        startX = linePoints[0][0];
                        startY = linePoints[0][1];
                        endX = linePoints[linePoints.length - 1][0];
                        endY = linePoints[linePoints.length - 1][1];
                        linePoints.forEach(function (p) {
                            if (p[0] < startX) {
                                startX = p[0];
                                startY = p[1];
                            }
                            else if (p[0] > endX) {
                                endX = p[0];
                                endY = p[1];
                            }
                        });
                        dy = endY - startY;
                        dx = endX - startX;
                        theta = Math.atan2(dy, dx);
                        theta *= 180 / Math.PI;
                        if (theta < 0) {
                            theta = 360 + theta;
                        }
                        // Need to enable rotation in order to update it; restore to configured value
                        this.mapView.constraints.rotationEnabled = true;
                        this.mapView.rotation = theta;
                        this.mapView.constraints.rotationEnabled = this._rotate;
                        window.dispatchEvent(new CustomEvent('mapUpdateEnd', { detail: '' }));
                        return [2 /*return*/];
                }
            });
        });
    };
    MapComponent.prototype.setSearchCriteriaFromQueryParameters = function (searchCriteria) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentSearchCriterias, searchCriterias;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.aoiService.setSearchCriterias([]);
                        currentSearchCriterias = this.aoiService.getSearchCriterias();
                        return [4 /*yield*/, this.deepLinkService.getSearchCriterias(currentSearchCriterias, searchCriteria.parameters)];
                    case 1:
                        searchCriterias = _a.sent();
                        this.aoiService.setSearchCriterias(searchCriterias);
                        return [2 /*return*/];
                }
            });
        });
    };
    MapComponent.prototype.getLinePointsAndCreateLineBuffer = function (layer, routeAndSegmentBufferTitle, getLinePoints, createBuffer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var linePoints, queryFeaturesResponse;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        linePoints = [];
                        if (!(layer != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, layer.queryFeatures()];
                    case 1:
                        queryFeaturesResponse = _a.sent();
                        queryFeaturesResponse.features.forEach(function (feature) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var buffers, buffer;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (getLinePoints) {
                                            feature.geometry.paths[0].forEach(function (p) {
                                                linePoints.push(p);
                                            });
                                        }
                                        if (!createBuffer) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this.nearbyService.getBuffers(25, 'feet', [feature.geometry])];
                                    case 1:
                                        buffers = _a.sent();
                                        buffer = buffers.map(function (b) { return b.graphic; });
                                        buffer.forEach(function (b) {
                                            // Note: cannot completely hide graphic buffer or it is not detected at all on screen
                                            b.symbol.color.a = 0;
                                            var outlineColor = b.symbol.outline.color;
                                            outlineColor.r = 255;
                                            outlineColor.g = 255;
                                            outlineColor.b = 255;
                                            outlineColor.a = 0.01;
                                        });
                                        return [4 /*yield*/, this.nearbyService.setNearbyLayer(routeAndSegmentBufferTitle, buffer, false)];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        _a.label = 2;
                    case 2: return [2 /*return*/, linePoints];
                }
            });
        });
    };
    MapComponent.prototype.onLargerImageRequested = function (documents) {
        this.largerImageRequest.emit(documents);
    };
    MapComponent.prototype.onLargerVideoRequested = function (documents) {
        this.largerVideoRequest.emit(documents);
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Array)
    ], MapComponent.prototype, "center", void 0);
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Number)
    ], MapComponent.prototype, "zoom", void 0);
    return MapComponent;
}(BaseComponent));
export { MapComponent };
